import React from 'react';
import styled from 'styled-components';

const ProductionRequestIcon = ({ width = 40, height = 41, color = '#00a4e3' }) => {
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="System / Printer">
        <path
          id="Vector"
          d="M30 28.8332C31.5531 28.8332 32.3297 28.8332 32.9423 28.5794C33.759 28.2411 34.4078 27.592 34.7461 26.7753C34.9998 26.1627 35 25.3868 35 23.8337V17.4948C35 15.6317 35 14.6987 34.637 13.9863C34.3175 13.3591 33.8062 12.8496 33.179 12.53C32.5097 12.1889 31.6473 12.168 30 12.1667M30 12.1667C29.8924 12.1667 29.7815 12.1667 29.667 12.1667H10.3337C10.219 12.1667 10.1078 12.1667 10 12.1668M30 12.1667L10 12.1668M30 12.1667V10.8282C30 8.96499 30 8.032 29.637 7.31966C29.3175 6.69245 28.8062 6.18289 28.179 5.86331C27.466 5.5 26.5338 5.5 24.667 5.5H15.3337C13.4668 5.5 12.5327 5.5 11.8197 5.86331C11.1925 6.18289 10.6829 6.69245 10.3633 7.31966C10 8.0327 10 8.96682 10 10.8337V12.1668M10 12.1668C8.35288 12.168 7.4889 12.189 6.81966 12.53C6.19245 12.8496 5.68289 13.3591 5.36331 13.9863C5 14.6994 5 15.6335 5 17.5003V23.8337C5 25.3868 5 26.1627 5.25373 26.7753C5.59205 27.592 6.24053 28.2411 7.05729 28.5794C7.66986 28.8332 8.44643 28.8332 9.99957 28.8332M16.6667 18.8333H23.3333M15 25.5H25C26.5531 25.5 27.3297 25.5 27.9423 25.7537C28.759 26.092 29.4078 26.7405 29.7461 27.5573C29.9998 28.1699 29.9998 28.9469 29.9998 30.5C29.9998 32.0531 29.9998 32.8297 29.7461 33.4423C29.4078 34.259 28.759 34.9078 27.9423 35.2461C27.3297 35.4998 26.5531 35.5 25 35.5H15C13.4469 35.5 12.6699 35.4998 12.0573 35.2461C11.2405 34.9078 10.592 34.2595 10.2537 33.4427C10 32.8301 10 32.0527 10 30.4996C10 28.9464 10 28.1699 10.2537 27.5573C10.592 26.7405 11.2405 26.092 12.0573 25.7537C12.6699 25.5 13.4469 25.5 15 25.5Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default React.memo(ProductionRequestIcon);
